import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import ru from 'vuetify/es5/locale/ru'
import theme from './themes/tradle.js'
Vue.use(Vuetify)
export default new Vuetify({
  theme: theme,
  iconfont: 'mdi',
  lang: {
    locales: { ru },
    current: 'ru'
  }
})
